import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/RewardTierCard.css';

const RewardTierCard = ({ 
  tier, 
  isEditing, 
  editingTier,
  onEdit, 
  onDelete, 
  onUpdate, 
  onCancel, 
  onChange,
  onImageUpload,
  loading
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  
  // If this card is being edited, show edit form
  if (isEditing) {
    return (
      <div className="reward-card">
        <div className="reward-edit-form">
          <div className="form-group">
            <label className="form-label">{t('rewards.tiers.form.name')}</label>
            <input 
              type="text" 
              name="name" 
              value={editingTier.name}
              onChange={onChange}
              className="form-input"
              dir={isRTL ? 'rtl' : 'ltr'}
            />
          </div>
          
          {/* Image upload field */}
          <div className="form-group">
            <label className="form-label">{t('rewards.tiers.form.image') || 'Reward Image'}</label>
            <div className="image-upload-container">
              {editingTier.imageUrl && (
                <div className="image-preview">
                  <img src={editingTier.imageUrl} alt={editingTier.name} />
                </div>
              )}
              <input 
                type="file" 
                accept="image/*"
                onChange={onImageUpload}
                className="image-upload-input"
                id={`image-upload-${editingTier.id}`}
              />
              <label 
                htmlFor={`image-upload-${editingTier.id}`} 
                className="image-upload-button"
              >
                {editingTier.imageUrl 
                  ? t('rewards.tiers.form.changeImage') || 'Change Image' 
                  : t('rewards.tiers.form.addImage') || 'Add Image'}
              </label>
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label">{t('rewards.tiers.form.pointsRequired')}</label>
            <input 
              type="number" 
              name="pointsRequired" 
              value={editingTier.pointsRequired}
              onChange={onChange}
              className="form-input"
              dir="ltr" // Always left-to-right for numbers
            />
          </div>
          <div className="form-group">
            <label className="form-label">{t('rewards.tiers.form.description')}</label>
            <textarea 
              name="description" 
              value={editingTier.description}
              onChange={onChange}
              className="form-textarea"
              rows="3"
              dir={isRTL ? 'rtl' : 'ltr'}
            ></textarea>
          </div>
          <div className="form-group checkbox">
            <label className="form-checkbox-label">
              <input 
                type="checkbox" 
                name="active" 
                checked={editingTier.active}
                onChange={onChange}
              />
              <span>{t('rewards.tiers.form.active')}</span>
            </label>
          </div>
          
          <div className="form-actions">
            <button 
              onClick={onUpdate} 
              className="primary-button"
              disabled={loading}
            >
              {loading ? t('common.updating') : t('rewards.tiers.form.buttons.update')}
            </button>
            <button 
              onClick={onCancel} 
              className="secondary-button"
              disabled={loading}
            >
              {t('rewards.tiers.form.buttons.cancel')}
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  // Otherwise, show regular display
  return (
    <div className="reward-card">
      <div className="reward-header">
        <div className="reward-title-row">
          <h4 className="reward-title">
            {tier.imageUrl && (
              <div className="tier-image-circle">
                <img src={tier.imageUrl} alt={tier.name} className="tier-image" />
              </div>
            )}
            {tier.name}
          </h4>
        </div>
        <div className="reward-points">
          {tier.pointsRequired.toLocaleString(i18n.language)}
          {!isRTL ? ` ${t('rewards.tiers.points')}` : ''}
        </div>
      </div>
      
      <div className="reward-description">
        {tier.description || t('rewards.tiers.form.noDescription')}
      </div>
      
      <div className="reward-actions">
        <button 
          onClick={() => onEdit(tier)} 
          className="edit-button"
        >
          {t('rewards.tiers.form.buttons.edit')}
        </button>
        <button 
          onClick={() => onDelete(tier.id)} 
          className="delete-button"
        >
          {t('rewards.tiers.form.buttons.delete')}
        </button>
      </div>
    </div>
  );
};

export default RewardTierCard;